/**
 * Created by Ivan on 17.05.2026
 */

const SeasonPassMerge2Adapter = {
    SubscribeToEvents: function () {
        cleverapps.missionManager.on("add", (mission) => {
            if (mission.getType() === Mission.TYPE_SEASON_PASS) {
                SeasonPassMerge2Adapter.bindCompletionAnimation(mission);
                cleverapps.eventBus.trigger("updateExtraBar");
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        const running = cleverapps.missionManager.findRunningMission(Mission.TYPE_SEASON_PASS);
        if (running) {
            SeasonPassMerge2Adapter.bindCompletionAnimation(running);
        }

        cleverapps.missionManager.on("remove", (mission) => {
            if (mission.getType() === Mission.TYPE_SEASON_PASS) {
                cleverapps.extraBar.removeIcon(SeasonPassExtraBarIcon);
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        cleverapps.eventBus.on("updateExtraBar", () => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_SEASON_PASS);
            if (!mission || !mission.isRunning()) {
                return;
            }

            if (cleverapps.resolution.isVertical()) {
                cleverapps.extraBar.removeIcon(SeasonPassExtraBarIcon, true);
            } else {
                cleverapps.extraBar.addIcon(SeasonPassExtraBarIcon);
            }
        });

        cleverapps.eventBus.on("complete_order", () => {
            SeasonPassMerge2Adapter.applyProgress("help_customers", 1);
        });

        cleverapps.eventBus.on("mapEvent", (eventType) => {
            if (eventType !== Field.MERGE) {
                return;
            }
            SeasonPassMerge2Adapter.applyProgress("merge_units", 1);
        });

        cleverapps.eventBus.on("spend_hard", (amount) => {
            if (!amount || amount <= 0) {
                return;
            }
            SeasonPassMerge2Adapter.applyProgress("spend_hard", amount);
        });

        cleverapps.eventBus.on("add_stars", (stars) => {
            if (!stars || stars <= 0) {
                return;
            }
            SeasonPassMerge2Adapter.applyProgress("earn_stars", stars);
        });
    },

    bindCompletionAnimation: function (mission) {
        const questPack = mission.logic && mission.logic.questPack;
        if (!questPack || questPack.completionAnimationBound) {
            return;
        }
        questPack.completionAnimationBound = true;

        questPack.on("questCompleted", (quest) => {
            SeasonPassQuestCompleteAnimation.show(quest);
        });
    },

    applyProgress: function (questType, amount) {
        if (typeof Mission === "undefined" || Mission.TYPE_SEASON_PASS === undefined) {
            return;
        }

        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_SEASON_PASS);
        if (!mission || !mission.isRunning() || !mission.logic || !mission.logic.questPack) {
            return;
        }

        mission.logic.questPack.applyProgress(questType, amount);
    }
};

cleverapps.whenAllInitialized(() => SeasonPassMerge2Adapter.SubscribeToEvents());
